var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTealMaskLBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 569,
    height: 651,
    viewBox: "0 0 569 651",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-192.119 299.718C-186.17 204.783 -140.04 115.094 -65.2824 56.2715C2.2902 3.10288 94.4502 -11.2 178.182 8.3516C247.761 24.5984 272.512 105.303 329.465 148.446C406.279 206.634 536.817 206.931 562.816 299.718C590.193 397.42 522.171 500.337 447.236 568.752C375.248 634.476 275.655 649.642 178.182 650.886C79.0621 652.15 -25.9018 643.916 -97.8271 575.707C-171.162 506.162 -198.438 400.583 -192.119 299.718Z",
    fill: "#EFFEFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTealMaskLBg);
export default __webpack_public_path__ + "static/media/teal-mask-l-bg.129480328496b0e1f176e95c98c633d2.svg";
export { ForwardRef as ReactComponent };